// TODO: Let's move all of this to the translations MS and have it all centralised somewhere.
//  That way it can be changed and handled by the analytics team and we won't
//  need to commit custom code with translations here 20220830:Alevale

import { last } from "lodash";

export const AnalyticsConstants = {
  names: {
    dataTrack: 'dataTrack',
  },
  categories: {
    internal: 'Internal',
    external: 'External',
    pathToPurchase: 'Path to purchase',
    informationShare: 'Information share',
    navigation: 'Navigation',
    browseAndShop: 'Browse and shop',
    searches: 'Searches',
    cta: 'CTA',
    globalHeader: 'Global Header',
    statusTracking: 'Status Tracking',
    checkout: 'Checkout',
    accManagement: 'Account Management',
    productSuggestion: 'Product Suggestion',
    addToCart: 'Add to Cart',
    template: 'Template',
    refineSearch: 'Refine Search',
    removeSearch: 'Search Remove',
    clearAll: 'Clear All',
    searchTerm: 'Search Term',
    search: 'Search',
    rma: 'RMA',
    error: 'Error',
    messages: 'Messages',
    notification: 'Notifications',
    transactions: 'Transactions',
    stockingLocations: 'Stocking Locations',
    checkPrice: 'Check Price',
    toggleReturnItems: 'Toggle selected return items',
    toggleAllReturnItems: 'Toggle all return items',
    toggleSelectedODReturnItem: 'Toggle selected order return item',
    toggleAllSelectedODReturnItems: 'Toggle all selected return items',
    removeItemFromReturnsCart: 'Remove return items from Cart',
    returnableItemsForOrder: 'Returnable Items For Order',
    returnableOrder: 'Return order ID',
    addItemsToReturnCart: 'Add Product to return Cart',
    ReturnCartItem: 'Return card Item',
    saveReturnOrderNotes: 'Save Return Order Note',
    fetchPackingInformation: 'Fetch Packing Information',
    getOrderFromReturnCart: 'Order From Return Cart',
    returnOrderSubmit: 'Submit Return Order',
    ReturPolicynViewed: 'Retur Policy Viewed',
    ReturnOrderWishlist: 'Return Order Wishlist',
    ReturnOrderReviewed: 'Return Order Reviewed',
    SaveReturnOrderNote: 'Save Return Order Note',
    DeviceRegistration: 'Device Registration',
    generateQuote: 'Generate Quote',
    eWarranty: 'eWarranty',
    productSelected: 'Product Selected',
    Help: 'Help',
    takeSurvey: 'Take Survey',
    cookies: 'Cookies',
    accountManagement: 'Account Management',
    clearSearch: 'Clear Search',
    orderVisibility: 'Order Visibility',
    orderDetails: 'Order Details',
    profilePreferences: 'Profile Preferences',
    adminApp: 'Admin App',
    manageCustomers: 'Manage Customers',
    manageEmployees: 'Manage Employees',
    translations: 'Translations',
    assignCustomers: 'Assign Customers',
    proceedToCheckout: 'Proceed to Checkout',
    shoppingLists: 'Shopping Lists',
    findMySalesRep: 'Find My Sales Rep',
    poPending: 'PO Pending',
    FAQ: 'FAQ',
    home: 'Home',
    cart: 'Cart',
    reviewOrder: 'Review Order',
    billAndReplace: 'Bill & Replace',
    initiateAReturn: 'Initiate a Return',
    productDetails: 'Product Details',
    statementOfAccount: 'Statement of Account',
    historyReport: 'History Report',
    invoiceDetails: 'Invoice Details',
    raiseDispute: 'Raise a Dispute',
    disputes: 'Dispute Overview',
    disputeDetails: 'Dispute Details',
    reopenDispute: 'Reopen Dispute',
    searchRemove: 'Search Remove',
    pathToParchase: 'Path to Parchase',
    download: 'Download',
    submissionDetails: 'Submission Details',
    submissionAccuracy: 'Submission Accuracy',
    endCustomer: 'End Customers',
    submissionStatusReport: 'Submission Status Report',
    customerAdmin: 'Customer Admin',
    catalog: 'Catalog',
    orders: 'Orders',
    initiateReturn: 'Initiate a Return',
    robustPriceCheck: 'Robust Price Check',
    shipments: 'Shipments',
    addToShoppingList: 'Add to Shopping List',
    serviceRequestOverview: 'Service Request Overview',
    productsOrdered: 'Products Ordered',
    inventoryConsignment: 'Inventory Consignment',
    ordersPendingApproval: 'Orders Pending Approval',
    equipmentsOverview: 'Equipments Overview',
    requestAccess: 'Request Access',
    registerConsumption: 'Register Consumption',
    userRegistration: 'User Registration',
    reportStockDiscrepancy: 'Report Stock Discrepancy'
  },
  actions: {
    commercialQuestion: 'Commercial Question',
    detailedFaqPage: 'Detailed FAQ Page',
    salesRepSearch:'Sales Rep Search',
    productsOrdered: 'Products Ordered',
    addQuantity: 'Add Quantity',
    addToCart: 'Add to Cart',
    removeQuantity: 'Remove Quantity',
    removeProduct: 'Delete Product',
    excelUpload: 'Excel Upload',
    cta: 'CTA',
    replaceCart: 'Replace Cart',
    checkPriceAndAvailability: 'Check Price & Availability',
    productSearched: 'Product Searched',
    productCatalog: 'Product catalog',
    clickPageName: pageName => `Clicks_${pageName}`,
    checkPrice: 'Check Price',
    priceAndAvailability: 'Price & Availability',
    rpvClicks: 'Clicks_Report Price variance',
    rpv: 'Report Price variance',
    searchTerm: 'Search Term',
    print: 'Print',
    download: 'Download',
    logo: 'Logo',
    openMenu: 'Open Menu',
    closeMenu: 'Close Menu',
    language: 'Language',
    languageSelected: 'Language Selected',
    notification: 'Notification',
    cart: 'Cart',
    profileMenu: 'Profile Menu',
    profileSubMenu: 'Profile Sub Menu',
    customerChange: 'Customer Change',
    customerSelected: 'Customer Selected',
    refineSearch: 'Refine Search',
    clearAll: 'Clear All',
    orderDetail: 'Order Detail',
    ClicksOrderDetailPage: 'Clicks_Order Detail Page',
    accFinancialInfo: 'Account Financial Info',
    salesRep: 'Sales Rep',
    clickSalesRepPage: 'Clicks_Find my Sales Rep Page',
    orderHistory: 'Order History',
    invoice: 'Invoice',
    downloadDeliveryNotes: 'Download Delivery Notes',
    reportOrderDiscrepancy: 'Report Order Discrepancy',
    retrivedDeliveryNotes: 'Retrived Delivery Notes',
    poPending: 'PO Pending',
    clickPOPendingPage: 'Clicks_PO Pending Page',
    viewDashboard: 'View Dashboard',
    requestAccess: 'Request Access',
    requestAccAccess: 'Request Account Access',
    forgotPwd: 'Forgot Password',
    login: 'Login',
    logout: 'Logout',
    contactUs: 'Contact Us',
    manageActiveCustomer: 'Manage Active Customer',
    creditCard: 'Credit Card',
    profileAndPreference: 'Profile & Preference',
    manageNotification: 'Manage Notifications',
    carrierAndShipping: 'Carrier & Shipping',
    billingAndPayment: 'Billing & Payment',
    orderId: 'Order ID',
    purchase: 'Purchase',
    billAndReplace: 'Bill and Replace',
    bill: 'Bill',
    draftOrders: 'Draft Orders',
    rmaHistory: 'RMA History',
    rmaDetail: 'RMA Detail',
    requestAdditionalAccount: 'Request Additional Account',
    accountAlignment: 'Account Alignment',
    rdtAlignment: 'RDT Alignment',
    termsAndCondition: 'Terms and Conditions',
    requestAdditionalAccess: 'Request Additional Access',
    portal: 'Portal',
    transactionType: 'Transaction Type',
    installBase: 'Install Base',
    createRma: 'Create RMA',
    soldToAndSsp: 'Sold To & SSP',
    viewCatalog: 'View Catalog',
    regionSelected: 'Region Selected',
    countrySelected: 'Country Selected',
    restrictedItem: 'Restricted Item',
    orders: 'Orders',
    shipments: 'Shipments',
    shipmentTracking: 'Shipment Tracking',
    invoices: 'Invoices',
    orderVisibility: 'Order Visibility',
    dropdownItem: (itemName) => `Dropdown Item:${itemName}`,
    loginError: 'Login Error',
    eWarranty: 'eWarranty',
    sendUsAnInquiry: 'Send us an Inquiry',
    downloadClaimForm: 'Download Claim Form',
    WarrantyClaimsViewed: 'Warranty Claims Viewed',
    filterRemoved: 'Filter Removed',
    filterApplied: 'Filter Applied',
    includeAllAccounts: 'Include All Accounts',
    clearSearch: 'Clear Search',
    orderDetails: 'Order Details',
    globalHeader: 'Global Header',
    viewBundleItems: 'View Bundle Items',
    notificationsChecked: 'Notifications Checked',
    notificationsSaveChecked: 'Notifications Save Checked',
    notificationsUnChecked: 'Notifications UnChecked',
    notificationsSaveUnChecked: 'Notifications Save UnChecked',
    notificationsSaveCancelled: 'Notifications Save Cancelled',
    modifyUsers: 'Modify Users',
    addAccessAndRoles: 'Add Access & Roles',
    editRoleOrPermission: (item) => `Edit Role or Permission${item}`,
    assignApps: 'Assign Apps',
    adminApp: 'Admin App',
    NewMessage: 'New Message',
    manageUsers: 'Manage Users',
    createUser: 'Create User',
    profilePreferences: 'Profile Preferences',
    search: 'Search',
    manageCustomers: 'Manage Customers',
    modifyCustomer: 'Modify Customer',
    manageEmployees: 'Manage Employees',
    cmsHome: 'CMS Home',
    delete: 'Delete',
    deleted: 'Deleted',
    cancelDelete: 'Cancel Delete',
    uploadExcel: 'Upload Excel',
    addNew: 'Add New',
    submitted: 'Submitted',
    cancel: 'Cancel',
    navigation: 'Navigation',
    translations: 'Translations',
    assignCustomers: 'Assign Customers',
    assignSalesOrg: 'Assign Sales Org',
    scanMode : 'Scan Mode',
    shoppingLists: 'Shopping Lists',
    renameShoppingLists: 'Rename Shopping Lists',
    deleteShoppingLists: 'Delete Shopping Lists',
    addSelectionsToCart: 'Add Selections to Cart',
    itemsRemoved: 'Items Removed',
    reportOrderDiscrepency: 'Report Order Discrepency',
    afterSalesQuestion: 'After Sales Question',
    contactCustomerCarePopupForm: 'Contact Customer Care Popup Form',
    footer: 'Footer',
    initiateExcelUpload: 'Initiate Excel Upload',
    billAndReplaceCheckbox: 'Bill & Replace Checkbox',
    addReplacementNote: 'Add Replacement Note',
    addProductNote: 'Add Product Note',
    addProduct: 'Add Product',
    checkout: 'Checkout',
    selectAll: 'Select All',
    returnContinue: 'Return Continue',
    returnCancel: 'Return Cancel',
    returnOverview: 'Return Overview',
    returnOrderSubmitted: 'Return Order Submitted',
    contactASalesRep: 'Contact a Sales Rep',
    disputes: 'Dispute Overview',
    viewDispute: 'View Dispute',
    viewInvoice: 'View Invoice',
    raiseADispute: 'Raise a Dispute',
    reopenDispute: 'Reopen Dispute',
    findMDTContacts: 'Find MDT Contacts',
    moreDetails: 'More Details',
    lessDetails: 'Less Details',
    returnCheckout: 'Return Checkout',
    template: 'Template',
    addtoList:'Add to List',
    addPoNumber:'Add PO Number',
    newShoppingList:'New Shopping List',
    rma: 'RMA',
    manageSubmissions: 'Manage Submissions',
    submissionDetails: 'Submission Details',
    uploadRecords: 'Upload Records',
    showRecordsWithErrors: 'Show Records with Errors',
    showDuplicateRecords: 'Show Duplicate Records',
    addRecords: 'Add Records',
    save: 'Save',
    saveAndAddAnother: 'Save & Add Another',
    submissionAccuracy: 'Submission Accuracy',
    filter: 'Filter',
    filterInteraction: 'Filter Interaction',
    endCustomer: 'End Customers',
    addNewCustomer: 'Add New Customer',
    submissionStatusReport: 'Submission Status Report',
    run: 'Run',
    submissionApprove: 'Submission Approve',
    view: 'View',
    catalog: 'Catalog',
    addToShoppingList: 'Add to Shopping List',
    podDownload: 'POD Download',
    inventory: 'Inventory',
    overview: 'Overview',
    search: 'Search',
    registerConsumption: 'Register Consumption',
    viewByProductCodeInventory: 'View By Product Code',
    viewBySerialNumberInventory: 'View By Serial Number',
    ordersPendingApproval: 'Orders Pending Approval',
    searchRemove: 'Search Remove',
    editOrderOPA: 'Edit Order',
    approveOPA: 'Approve',
    rejectOPA: 'Reject',
    manageCreditCards: 'Manage Credit Cards',
    shippingAddressModifyorAdd: 'Shipping Address : Modify or Add',
    requestAccess: 'Request Access',
    reportStockDiscrepancy: 'Report Stock Discrepancy'
  },
  labels: {
    readTermsConditions: 'Read Terms & Conditions',
    readMedtronicPrivacyPolicy: 'Read Medtronic Privacy Policy',
    formSubmitted: 'Form Submitted',
    formCancelled: 'Form Cancelled',
    contactCustomerCare: 'Contact Customer Care',
    contactMySalesRep: 'Contact My Sales Rep',
    addQuantity: (pageType, productId) => `Add Quantity_${pageType}_Product Id - ${productId}`,
    removeQuantity: (pageType, productId) => `Remove Quantity_${pageType}_Product Id - ${productId}`,
    removeProduct: productId => `Remove Product Id: ${productId}`,
    initiateExcelUpload: 'Initiate Excel Upload',
    excelUpload: 'Excel Uploaded',
    rpvLabels: productId => `Report Price Variance_Product Id - ${productId}`,
    rpvLabelsOnSubmit: productId => `Report Price Variance_Product Id - ${productId}`,
    addToCart: str => `Product Id - ${str}`,
    replaceCart: productId => `Replace Cart_Product Id - ${productId}`,
    addAnotherProductToCart: 'Add another product to cart',
    checkPriceAndAvailability: (pageName, productId) => `Check Price & Availability_${pageName}_Product Id - ${productId}`,
    productSearched: term => `Product Searched - ${term}`,
    browseProductCatalog: 'Browse Product catalog',
    clickedCheckPrice: productId => `Clicked_Check Price - ${productId}`,
    productNotFound: 'Product Not Found',
    clickedRpv: productId => `Report Price Variance: ${productId}`,
    printProductId: productId => `Product Detail: ${productId}`,
    productCatalogViewed: 'Product Catalog Viewed',
    downloadedCatalog: 'Catalog',
    clearFacetSearch: pageName => `${pageName}_Clear Search`,
    clickProduct: productId => `Product - ${productId}`,
    orderDetailView: orderId => `Viewed_Order ID - ${orderId}`,
    searchedTermOrderDetail: (pageName, term) => `${pageName}_Searched_${term}`,
    printOrderDetail: id => `Order Detail: ${id}`,
    downloadOrderDetail: id => `Order Detail: ${id}`,
    clickOrderId: id => `Order ID: ${id}`,
    clickDisputeId: id => `Order ID: ${id}`,
    clicksItemType: type => `Clicked_${type}`,
    clickedProductId: id => `Product ID: ${id}`,
    clickedTrackingUrl: id => `Tracking URL: ${id}`,
    clickedTracking: id => `Tracking: ${id}`,
    downloadInvoice: id => `Invoice: ${id}`,
    accFinancialInfo: id => `Account Financial Info Viewed_Customer ID - ${id}`,
    searchSuggestionSelected: (pageName, term) => `${pageName}_Search Suggestion Selected_${term}`,
    emailLink: 'Email Link',
    viewAllAccounts: 'View All Accounts',
    searchedProduct: (pageName, term) => `${pageName}_Searched_${term}`,
    downloadedOrderHistory: 'Order History',
    orderHistoryViewed: 'Order History Viewed',
    noOrderHistory: 'No Order History',
    downloadedInvoice: id => `Invoice: ${id}`,
    emailInvoice: id => `Email Invoice: ${id}`,
    selectAllInvoice: 'Selected_All Invoices',
    reportOrderDiscrepancy: id => `Report Order Discrepancy - ${id}`,
    retrivedDeliveryNotesEmail: id => `Retrived Delivery Notes | Email_${id}`,
    retrivedDeliveryNotesDownload: id => `Retrived Delivery Notes | Downloaded_${id}`,
    clickedAddPONumber: id => `Add PO Number: ${id}`,
    clickedEditPONumber: id => `Edit PO Number: ${id}`,
    downloadedPOPending: 'PO Pending',
    dashboardViewed: 'Dashboard Viewed',
    initiated: 'Initiated',
    stepOneCompleted: 'Step 1 Completed',
    submitted: 'Submitted',
    requestAccAccess: roles => `Request Account Access_${roles}`,
    contactUsSubmitted: 'Form Submitted',
    selectedCustomer: id => `Selected_Customer ID : ${id}`,
    added: 'Added',
    deleted: 'Deleted',
    edited: 'Edited',
    initiateEditContact: 'Initiate Edit Contact Info',
    updatedContactInfo: 'Updated Contact Info',
    initiatePwdReset: 'Initiated Edit Password Reset',
    updatedPwd: 'Updated Password',
    initiateShippingAndBilling: 'Initiate Edit Shipping & Billing Preferences',
    initiateProfilePreference: 'Initiate Edit Profile Preferences',
    deleteManualAlignedTerritory: 'Delete Manual Aligned Territory',
    addManualAlignedTerritory: 'Added Manual Aligned Territory',
    initiateCrossChannelNotification: 'Initiate Edit Manage Notifications',
    savedCrossChannelNotification: 'Saved Cross Channel Notifications',
    orderId: id => `Order ID: ${id}`,
    checkout: 'Checkout',
    proceedToCheckout: 'Proceed To Checkout',
    quickLink: 'Quick Links',
    exitCheckout: 'Exit Checkout',
    addNotes: 'Add Notes',
    productId: id => `Product ID: ${id}`,
    productAdded: str => `Product Added: ${str}`,
    deleteTemplate: tempName => `Deleted Template: ${tempName}`,
    patientInfoAdded: 'Patient Info Added',
    deletedDraft: ids => `Deleted: ${ids}`,
    continueDraft: ids => `Continue: ${ids}`,
    clearSearch: 'Clear Search',
    rmaHistory: 'RMA History',
    rmaHistoryViewed: 'RMA History Viewed',
    rmaInstallBase: 'RMA Install Base',
    rmaDetailViewed: id => `RMA Detail Viewed: ${id}`,
    rmaDetailId: id => `RMA Detail: ${id}`,
    tabName: tab => `Tab Name: ${tab}`,
    manangeMyAccount: 'Manage My Accounts',
    addSymbol: 'Add Symbol',
    deletedManuallyAlignedAccount: 'Deleted Manually Aligned Account',
    addedAccount: id => `Added Account: ${id}`,
    rdtAlignAccShow: id => `RDT Aligned_Account Show: ${id}`,
    rdtAlignAccHide: id => `RDT Aligned_Account Hide: ${id}`,
    viewed: 'Viewed',
    requestAdditionalAccess: id => `Request Additional Request_${id}`,
    shippingAddressAdded: 'Shipping Address Added',
    shippingAddressModified: 'Shipping Address Modified',
    error: msg => `Error: ${msg}`,
    messageAcknowledged: 'Message Acknowledged',
    markRead: 'Marked Read',
    deletedProduct: id => `Removed Product Id: ${id}`,
    requestFacilitySubmitted: 'Request Facility Submitted',
    submittedRma: id => `Submitted RMA with Serial Number: ${id}`,
    addToCartProduct: id => `Add to Cart: ${id}`,
    allDeliveryNotes: 'Selected_All Delivery Notes',
    logoClicked: 'Logo_Clicked',
    download: 'Download',
    downloaded: 'Downloaded',
    cancel: 'Cancel',
    needHelp: 'Need help?',
    surveyClicks: 'Survey Clicks',
    submit: 'Submit',
    go: 'GO',
    ok: 'OK',
    saveAsTemplate: 'Save as Template',
    templateSaved: 'Template Saved',
    readMore: 'Read More',
    displayName: name => name,
    deliveryNotes: id => `DeliveryNotes: ${id}`,
    moreDetails: id => `More Details: ${id}`,
    viewOrderDetails: id => `View Order Details: ${id}`,
    invoiceDetails: id => `Invoice Details: ${id}`,
    productDetails: id => `Product ID: ${id}`,
    orderDetails: id => `Order Details: ${id}`,
    shipmentDetails: id => `Shipment Details: ${id}`,
    viewShipmentDetails: id => `View Shipment Details: ${id}`,
    view: id => `View: ${id}`,
    dashboard: 'Dashboard',
    productsOrdered: 'Products Ordered',
    orders: 'Orders',
    shipments: 'Shipments',
    invoices: 'Invoices',
    searchText: 'Search Text',
    includeAllAccounts: isToggle => `Include All Account: Switched ${isToggle ? 'On' : 'Off'}`,
    downloadExcel: 'Download Excel',
    clearAll: 'Clear All',
    mail: 'Mail',
    quickView: (status) => `Quick View:${status}`,
    refineSearch: (facetName, itemName) => `Category: ${facetName} & Sub Category: ${itemName}`,
    restrictedUser: 'Restricted User',
    expandAll: 'Expand All',
    collapseAll: 'Collapse All',
    inquirySubmitted: (claimId) => `Inquiry Submitted:${claimId}`,
    productNumberClicked: productNumber => `Product Number Clicked: ${productNumber}`,
    serialLotNumberViewed: 'Serial / Lot Number Viewed',
    serialLotNumberViewClosed: 'Serial / Lot Number View Closed',
    viewPackingSlip: id => `View Packing Slip: ${id}`,
    notificationsSaveCancelled: 'Manage Notifications Save Cancelled',
    notificationsUnsubscribe: 'Notifications unsubscribe',
    addAccessAndRoles: 'Add Access & Roles',
    editRoleOrPermission: 'Edit Role or Permission',
    save: 'Save',
    assignApps: 'Assign Apps',
    back: 'Back',
    selectCustomer: (customerId) => `Select Customer : ${customerId}`,
    searchCustomer: (searchText) => `Search Customer: ${searchText}`,
    continue: (appAndRole) => `Continue:${appAndRole}`,
    createUser: 'Create User',
    successful: 'Successful',
    modify: 'Modify',
    create: (id) => `Create: ${id}`,
    createCustomer: (id) => `Create Customer: ${id}`,
    duplicateCustomer: (id) => `Duplicate Customer: ${id}`,
    assignSalesOrg: 'Assign Sales Org',
    editCustomer: (id) => `Edit Done: ${id}`,
    addSalesOrgDone: (id) => `Add Sales Org Done: ${id}`,
    modifyCustomer: (id) => `Modify Customer: ${id}`,
    saved: (id) => `Saved:${id}`,
    cmsWidget: ({ feature }) => `Widget: ${feature}`,
    translationSearchText: ({ app, language, searchText }) => `${app} | ${language} | ${searchText}`,
    downloadTemplate: 'Download Template',
    uploadIconClicked: 'Upload Icon Clicked',
    uploadCancel: 'Upload Cancel',
    iconClicked: 'Icon Clicked',
    uploadCompleted: 'Upload Completed',
    newTranslation: ({ app, locale, key }) => `App: ${app}, Locale: ${locale}, Key: ${key}`,
    paginationClicked: ({ value }) => `Pagination Clicked: ${value}`,
    deleteTranslationKey: ({ key }) => `${key}`,
    downloadIconClicked: 'Download Icon Clicked',
    complete: 'Complete',
    assignCustomers: 'Assign Customers',
    customerRemoved: (customer_ID) => `Customer Removed: ${customer_ID}`,
    continueAccessAndRoles: (Id)=> `Continue Access & Roles: ${Id}` ,
    continueAssignSalesOrg: (Id)=> `Assign Sales Org: ${Id}`,
    activated: 'Activated',
    addToCartStr : 'Add to Cart',
    checkPrice: 'Check Price',
    deactivated: 'Deactivated',
    manageShoppingLists: 'Manage Shopping Lists',
    renameShoppingLists: 'Rename Shopping Lists',
    reportPriceVariance: 'Report Price Variance',
    reportPriceVarianceSubmit: (Id) => `Report Price Variance - ${Id}`,
    searchAgain: 'Search Again',
    deleteShoppingLists: 'Delete Shopping Lists',
    delete: 'Delete',
    addItemsToCart: 'Add Items to Cart',
    viewAllAccountsTurnedOff : 'View All Accounts: Turned Off',
    bundlePopUpOpen: (bundleName) => `Bundle: ${bundleName}`,
    bundlePopUpClosed: (bundleName) => `Close Bundle Popup: ${bundleName}`,
    billReplaceProductId: (id) => `Product: ${id}`,
    selectedId: (id) => `Selected: ${id}`,
    deselectedId: (id) => `Deselected: ${id}`,
    open: 'Open',
    closed: 'Closed',
    productId: (id) => `Product: ${id}`,
    checkoutProductId: (id) => `Checkout: ${id}`,
    addMoreProduct: 'Add More Product',
    returnOverview: 'Return Overview',
    productView: (id) => `Product View: ${id}`,
    deleteProductId: (id) => `Delete Product: ${id}`,
    deleteInitiateProductId: (id) => `Initiated: ${id}`,
    cancelInitiateProduct: (id) => `Cancel: ${id}`,
    addItem:'Add Item',
    deleteRow:'Delete Row',
    poNumber: (po) => `PO#: ${po}`,
    addToShoppingList: (id) => `Add to Shopping List: ${id}`,
    requestAdditionalAccess: 'Request Additional Access',
    manageCreditCards: 'Add',
    creditCardAdded: 'Add New Credit Card',
    requestAccessAdditionalFacility: 'Request Access to Additional Facility',
    shippingAddressModifyorAdd: 'Shipping Address : Modify or Add',
    addNew: 'Add New',
    edit: 'Edit',
  },
  values: {
    one: 1,
  }
}
